import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import commonComponents from '@/components/common/'
import { Toast } from 'vant'
// 全局注册组件
Vue.use(commonComponents);

Toast.setDefaultOptions({ duration: 1500 });

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
